module.exports = __webpack_public_path__ + "img/28.7d1d00de.jpg";